import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export type SystemStatus = 'open' | 'busy' | 'closed';

export interface SystemStatusResponse {
  status: SystemStatus;
  is_open?: boolean;
  working_hours_start?: string;
  working_hours_end?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SystemService {
  private apiUrl = environment.apiUrl;
  private systemStatusSubject = new BehaviorSubject<SystemStatus>('open');
  public systemStatus$ = this.systemStatusSubject.asObservable();

  constructor(private http: HttpClient) {
    // Otomatik istek kaldırıldı: Her sekme açılışında N istek gitmesin.
    // Sistem durumu captain panel açıldığında loadSystemStatus() ile yüklenecek.
  }

  getSystemStatus(): Observable<SystemStatusResponse> {
    return this.http.get<SystemStatusResponse>(`${this.apiUrl}/system/status`)
      .pipe(
        tap((status) => {
          const resolvedStatus: SystemStatus =
            status.status ||
            (status.is_open ? 'open' : 'closed');
          this.systemStatusSubject.next(resolvedStatus);
        })
      );
  }

  updateSystemStatus(status: SystemStatus): Observable<any> {
    return this.http.put(`${this.apiUrl}/system/status`, { status })
      .pipe(
        tap({
          next: (response: any) => {
            console.log('System status update response:', response);
            const resolvedStatus: SystemStatus =
              response?.status ||
              (response?.is_open ? 'open' : 'closed');
            this.systemStatusSubject.next(resolvedStatus);
          },
          error: (error) => {
            console.error('System status update error:', error);
            console.error('Error status:', error.status);
            console.error('Error message:', error.message);
            console.error('Error body:', error.error);
          }
        })
      );
  }

  getWorkingHours(): Observable<{ working_hours_start: string; working_hours_end: string }> {
    return this.http.get<{ working_hours_start: string; working_hours_end: string }>(`${this.apiUrl}/system/working-hours`);
  }

  getTimeoutSettings(): Observable<{ request_timeout_minutes: number }> {
    return this.http.get<{ request_timeout_minutes: number }>(`${this.apiUrl}/system/timeout-settings`);
  }

  getAutoResponseSettings(): Observable<{ unanswered_request_minutes_threshold: number }> {
    return this.http.get<{ unanswered_request_minutes_threshold: number }>(`${this.apiUrl}/system/auto-response-settings`);
  }

  updateWorkingHours(working_hours_start: string, working_hours_end: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/system/working-hours`, {
      working_hours_start,
      working_hours_end
    });
  }

  private loadSystemStatus(): void {
    this.getSystemStatus().subscribe();
  }
}

